<span
    class="copyable-text"
    role="button"
    tabindex="0"
    [attr.aria-label]="'Copy ' + displayText + ' to clipboard'"
    (click)="copy()"
    (keydown.enter)="copy()"
    (keydown.space)="copy(); $event.preventDefault()">
  <span class="copyable-text-label">{{displayText}}</span>
  <fa-icon class="copyable-text-icon" [class.copied]="copied" [icon]="copied ? faCheck : faCopy" [fixedWidth]="true" aria-hidden="true"></fa-icon>
</span>
